<template>
  <RouterView :key="$route.fullPath" />
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { useResultsStore } from './stores/results-fetcher.js'
import { eventIsLive, setLiveFavicon } from './utils/live-favicon.js'

const LIVE_CHECK_MS = 30000

export default {
  name: 'App',
  setup() {
    return { resultsStore: useResultsStore() }
  },
  data() {
    return { timer: null }
  },
  computed: {
    // The store keeps the previous event until the next one loads - ignore it for another alias.
    currentEvent() {
      const event = this.resultsStore.event?.event
      if (!event) return null
      const alias = this.$route.params.eventAlias
      return event.alias && alias && event.alias !== alias ? null : event
    }
  },
  watch: {
    currentEvent() {
      this.updateLive()
    }
  },
  mounted() {
    this.updateLive()
    // the event starts / ends while the page is open
    this.timer = setInterval(this.updateLive, LIVE_CHECK_MS)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    updateLive() {
      setLiveFavicon(eventIsLive(this.currentEvent))
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>
